var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_13900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_13900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 12.1654C2.69427 12.1654 2.57555 12.1174 2.47977 12.0215C2.38388 11.9256 2.33594 11.8069 2.33594 11.6652C2.33594 11.5234 2.38388 11.4047 2.47977 11.309C2.57555 11.2133 2.69427 11.1654 2.83594 11.1654H5.41927C5.56094 11.1654 5.67966 11.2133 5.77544 11.3092C5.87133 11.4051 5.91927 11.5239 5.91927 11.6655C5.91927 11.8073 5.87133 11.926 5.77544 12.0217C5.67966 12.1175 5.56094 12.1654 5.41927 12.1654H2.83594ZM2.83594 8.9987C2.69427 8.9987 2.57555 8.95075 2.47977 8.85486C2.38388 8.75898 2.33594 8.6402 2.33594 8.49853C2.33594 8.35675 2.38388 8.23803 2.47977 8.14236C2.57555 8.04659 2.69427 7.9987 2.83594 7.9987H9.2911C9.43277 7.9987 9.55149 8.04664 9.64727 8.14253C9.74316 8.23842 9.7911 8.3572 9.7911 8.49886C9.7911 8.64064 9.74316 8.75936 9.64727 8.85503C9.55149 8.95081 9.43277 8.9987 9.2911 8.9987H2.83594ZM2.83594 5.83203C2.69427 5.83203 2.57555 5.78409 2.47977 5.6882C2.38388 5.59231 2.33594 5.47353 2.33594 5.33186C2.33594 5.19009 2.38388 5.07136 2.47977 4.9757C2.57555 4.87992 2.69427 4.83203 2.83594 4.83203H13.1693C13.3109 4.83203 13.4297 4.87998 13.5254 4.97586C13.6213 5.07175 13.6693 5.19053 13.6693 5.3322C13.6693 5.47398 13.6213 5.5927 13.5254 5.68836C13.4297 5.78414 13.3109 5.83203 13.1693 5.83203H2.83594Z",
    fill: "#495667"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.bc45779830689a255e0a52b8f786de83.svg";
export { ForwardRef as ReactComponent };